import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('inventory');
  this.route('explore');
  this.route('settings', function () {
    this.route('connections', function () {
      this.route('index');
      this.route('create');
      this.route('detail', {
        path: '/:connector_id'
      });
    });
  });
});